import { EMAIL_SCHEMA } from '@shared/config';
import * as yup from 'yup';

export const forgotPasswordValidationSchema = yup.object({
  email: EMAIL_SCHEMA,
});
export type ForgotPasswordRequestData = yup.InferType<typeof forgotPasswordValidationSchema>;
